import { EntityRoutes } from 'routes/constants';
import { JobOrderIncludes } from 'services/includes';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { ENTITY_TYPE_ID_MAP, JobOrderEntity, TabKeys } from 'UI/constants/entityTypes';
import { PERSISTENCE_KEYS } from 'UI/constants/persistenceKeys';

export const JOB_ORDER_DRAWERS = {
  Claim: 'claim',
  Edit: 'edit',
  Placement: 'placement',
  Presentation: 'presentation',
  Recruiters: 'recruiters',
  Roleplay: 'roleplay',
  Sendout: 'sendout',
  SendoutUnavailable: 'sendoutUnavailable',
  Task: 'task',
  VerifyUrgency: 'verifyUrgency'
};

export const JOB_ORDER_TAB_IDS = {
  Overview: TabKeys.Overview,
  JobDescription: TabKeys.JobDescription,
  MatchMaking: TabKeys.MatchMaking,
  Sendouts: TabKeys.Sendouts,
  SendoutsV2: TabKeys.SendoutsV2,
  Placements: TabKeys.Placements,
  Candidates: TabKeys.Candidates,
  HiringAuthorities: TabKeys.HiringAuthorities,
  ActionPlan: TabKeys.Tasks
};

export const JOB_ORDER_PROFILE_CONFIG = {
  endpoint: Endpoints.JobOrders,
  entityTypeId: ENTITY_TYPE_ID_MAP.jobOrder,
  id: JobOrderEntity.id,
  includes: () => [JobOrderIncludes],
  requestAssignmentLabel: strings.inventoryProfiles.common.startRecruiting,
  route: id => EntityRoutes.JobOrderProfile.replace(':id', id),
  sectionName: JobOrderEntity.singular,
  tabsStorageKey: PERSISTENCE_KEYS.PROFILE_TABS.JOB_ORDERS,
  tabsSubheader: `${JobOrderEntity.singular} ${strings.inventoryProfiles.title}`,
  title: JobOrderEntity.title,
  trackingUrl: Endpoints.JobOrderRecentlyViewed,
  type: 'jobOrder'
};
